import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { UserFollowedDataObjectGroupQueryDtoType } from '../schema/types';
import { UserFollowedDataObjectGroupUrl } from './UserFollowedDataObjectGroupUrl';
import { Page, PageRequestParams } from '../../../../common/queryClient';

export const DASHBOARD_GROUP_TABLE_PAGE_SIZE = 11;

export interface UserFollowedDataObjectGroupFilter {
  dataObjectGroup?: string;
}

export type UserFollowedDataObjectGroupParams =
  UserFollowedDataObjectGroupFilter &
    PageRequestParams<keyof UserFollowedDataObjectGroupFilter>;

const getUserFollowedDataObjectGroups = (
  params: UserFollowedDataObjectGroupParams,
) =>
  apiClient
    .get<Page<UserFollowedDataObjectGroupQueryDtoType>>(
      expand(UserFollowedDataObjectGroupUrl.base, {
        ...params,
        size: DASHBOARD_GROUP_TABLE_PAGE_SIZE,
      }),
    )
    .then((response) => response.data);

export const useListUserFollowedDataObjectGroupQuery = createApiQueryHook(
  ['user-followed-data-object-groups'],
  getUserFollowedDataObjectGroups,
);
